interface Environment {
  API_BASE_URL: string;
  NODE_ENV: string;
  ONESIGNAL_APP_ID: string | undefined;
  ABLY_API_KEY: string | undefined;
}

const getApiBaseUrl = (): string => {
  // If VITE_API_BASE_URL is explicitly set, use it
  if (import.meta.env.VITE_API_BASE_URL) {
    return import.meta.env.VITE_API_BASE_URL;
  }

  // Otherwise, determine based on NODE_ENV
  const nodeEnv = import.meta.env.NODE_ENV || "development";

  switch (nodeEnv) {
    case "production":
      return "https://api.zarity.health";
    case "staging":
      return "https://dev.api.zarity.health";
    case "development":
    default:
      // For development, try to use staging if localhost doesn't work
      return "https://dev.api.zarity.health";
  }
};

export const env: Environment = {
  API_BASE_URL: getApiBaseUrl(),
  NODE_ENV: import.meta.env.NODE_ENV || "development",
  ONESIGNAL_APP_ID: import.meta.env.VITE_ONESIGNAL_APP_ID,
  ABLY_API_KEY: import.meta.env.VITE_ABLY_API_KEY,
} as const;

export const isStaging = env.API_BASE_URL.includes("dev.api.zarity.health");

// Validate required environment variables on startup
if (!env.ABLY_API_KEY) {
  throw new Error(
    "VITE_ABLY_API_KEY is required. Copy .env.example to .env and fill in values."
  );
}

if (!env.API_BASE_URL) {
  throw new Error(
    "VITE_API_BASE_URL is required. Copy .env.example to .env and fill in values."
  );
}
